var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTunner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4135_34538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4135_34538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 33V32H20C19.7167 32 19.4792 31.9042 19.2875 31.7125C19.0958 31.5208 19 31.2833 19 31V21C19 20.7167 19.0958 20.4792 19.2875 20.2875C19.4792 20.0958 19.7167 20 20 20H21V19C21 18.7167 21.0958 18.4792 21.2875 18.2875C21.4792 18.0958 21.7167 18 22 18C22.2833 18 22.5208 18.0958 22.7125 18.2875C22.9042 18.4792 23 18.7167 23 19V20H24C24.2833 20 24.5208 20.0958 24.7125 20.2875C24.9042 20.4792 25 20.7167 25 21V31C25 31.2833 24.9042 31.5208 24.7125 31.7125C24.5208 31.9042 24.2833 32 24 32H23V33C23 33.2833 22.9042 33.5208 22.7125 33.7125C22.5208 33.9042 22.2833 34 22 34C21.7167 34 21.4792 33.9042 21.2875 33.7125C21.0958 33.5208 21 33.2833 21 33ZM21 30H23V22H21V30ZM29 33V29H28C27.7167 29 27.4792 28.9042 27.2875 28.7125C27.0958 28.5208 27 28.2833 27 28V23C27 22.7167 27.0958 22.4792 27.2875 22.2875C27.4792 22.0958 27.7167 22 28 22H29V19C29 18.7167 29.0958 18.4792 29.2875 18.2875C29.4792 18.0958 29.7167 18 30 18C30.2833 18 30.5208 18.0958 30.7125 18.2875C30.9042 18.4792 31 18.7167 31 19V22H32C32.2833 22 32.5208 22.0958 32.7125 22.2875C32.9042 22.4792 33 22.7167 33 23V28C33 28.2833 32.9042 28.5208 32.7125 28.7125C32.5208 28.9042 32.2833 29 32 29H31V33C31 33.2833 30.9042 33.5208 30.7125 33.7125C30.5208 33.9042 30.2833 34 30 34C29.7167 34 29.4792 33.9042 29.2875 33.7125C29.0958 33.5208 29 33.2833 29 33ZM29 27H31V24H29V27Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunner);
export default __webpack_public_path__ + "static/media/tunner.bf769f41234248b30b06f1895c72c9ce.svg";
export { ForwardRef as ReactComponent };